import { client } from './client';
import { endpoints } from './endpoints';

interface RejectionReason {
  rejectionReason: string;
  titleAr: string;
  titleEn: string;
}

interface Group {
  groupUUID: string;
  groupNameAr: string;
  groupNameEn: string;
  expectedHandlingTime: number;
  expectedWaitingTime: number;
}

interface Restaurant {
  restaurantUUID: string;
  restaurantLogo: string;
  restaurantArName: string;
  restaurantEnName: string;
  expectedHandlingTime: number;
  expectedWaitingTime: number;
}
type BranchAddressLookups = {
  zoneNameAr: string;
  zoneNameEn: string;
  areaNameAr: string;
  areaNameEn: string;
  cityNameAr: string;
  cityNameEn: string;
  branchUUID: string;
  branchAddressAr: string;
  branchAddressEn: string;
  restaurantNameAr: string;
  restaurantNameEn: string;
};

export interface FetchLookupsResponse {
  userCode: string;
  userStatus: boolean;
  userUUID: string;
  userLanguage: string;
  rejectionReasons: RejectionReason[];
  branchesUuids: string[];
  group?: Group;
  restaurants: Restaurant[];
  branchesAddress: BranchAddressLookups[];
}

export async function fetchLookups(): Promise<FetchLookupsResponse> {
  const response = await client.get(endpoints.LOOKUPS);

  return response.data;
}
